import { AuthBindings } from "@refinedev/core";
import axios from "axios";
import { config } from "config";
import getData, { fetchData } from "./helper";
import { initAuthorization } from "rest-data-provider/utils/tools";
const authUrl = config().server.identity;
export const authProvider: AuthBindings = {
  login: async ({ name, email, password }) => {
    const postData = {
      email: email,
      password: password,
    };
    const authResponse = await axios.post(
      `${authUrl}/authentication`,
      postData
    );
    const authToken = authResponse.data.token;
    const sessionData = await fetchData("v2/admin/user/session", authToken);
    
    const user = sessionData.metadata.user;
    if (user.group === 0 || user.group === 1) {
      window.sessionStorage.setItem("authorization", authToken);
      window.sessionStorage.setItem(
        "user",
        JSON.stringify(sessionData.metadata.user)
      );
      initAuthorization();
      return {
        success: true,
        redirectTo: "/",
      };
    } else {
      return {
        success: false,
        error: {
          message: "Login Error",
          name: "Invalid Login",
        },
      };
    }
  },
  logout: async () => {
    sessionStorage.removeItem("authorization");
    sessionStorage.removeItem("user");
    return {
      success: true,
      redirectTo: "/login",
    };
  },
  check: async () => {
    const token = sessionStorage.getItem("authorization");
    if (token) {
      return {
        authenticated: true,
      };
    }
    return {
      authenticated: false,
      redirectTo: "/login",
    };
  },
  getPermissions: async () => null,
  getIdentity: async () => {
    const authorization = sessionStorage.getItem("authorization");
    if (authorization) {
      const result = await getData(authorization);
      return result;
    }
    return null;
  },
  onError: async (error) => {
    console.error(error);
    return { error };
  },
};
